<form [formGroup]="input.formGroup" class="editor-form mt-3">
	<nz-card [nzTitle]="cardTitle" [nzExtra]="sectionCardExtra" class="mt-3" [ngClass]="{'danger-card': !input.formGroup.valid}">
		<ng-template #cardTitle>
			<app-invalid-form-indicator [form]="input.formGroup" class="me-3"></app-invalid-form-indicator>
			Section: {{input._label}}
		</ng-template>
		<ng-template #sectionCardExtra>
			<button nz-button nzType="dashed" (click)="doEdit()" class="me-3">
				<app-invalid-form-indicator [form]="input.formGroup" [fields]="['label','sectionOrder']" class="me-3"></app-invalid-form-indicator>
				<span *ngIf="isProductWorkflow">View</span>
				<span *ngIf="!isProductWorkflow">Edit</span>
			</button>
			<button *ngIf="!isProductWorkflow" nz-button nzType="primary" (click)="doRemove()" nzDanger><fa-icon [icon]="faTrash"></fa-icon></button>
		</ng-template>

		<nz-form-item *ngFor="let item of input.elements" (dblclick)="viewProperty(item)">
			<nz-form-label [nzSpan]="10" [nzRequired]="item._required" [nzNoColon]="item._dataType == 'Boolean' || item._dataType == 'RequiredCheckbox'">
				<app-invalid-form-indicator [form]="item.formGroup" class="me-3"></app-invalid-form-indicator>
				<span *ngIf="item._dataType != 'Boolean' && item._dataType != 'RequiredCheckbox'">{{item._label}}</span>
			</nz-form-label>
			<nz-form-control [nzSpan]="14">
				<nz-input-group  *ngIf="!isProductWorkflow" [nzAddOnAfter]="deleteElementTmpl" [ngSwitch]="item._dataType">
					<textarea *ngSwitchCase="'TextArea'" nz-input [attr.readonly]="true || null"></textarea>
					<label *ngSwitchCase="'Boolean'" nz-checkbox [nzDisabled]="true">{{item._label}}</label>
					<label *ngSwitchCase="'RequiredCheckbox'" nz-checkbox [nzDisabled]="true">{{item._label}}</label>
					<nz-select *ngSwitchCase="'DropDownSingle'" [nzDisabled]="true">
						<nz-option *ngFor="let option of item.options" [nzValue]="option._value" [nzLabel]="option._label??'No Label'"></nz-option>
					</nz-select>
					<nz-select *ngSwitchCase="'ICD10'" [nzDisabled]="true"></nz-select>
					<nz-select *ngSwitchCase="'ServiceProviderID'" [nzDisabled]="true"></nz-select>
					<nz-select *ngSwitchCase="'DependantList'" [nzDisabled]="true"></nz-select>
					<nz-select *ngSwitchCase="'MemberAndDependantList'" [nzDisabled]="true"></nz-select>
					<input *ngSwitchCase="'Number'" nz-input [attr.readonly]="true || null" />
					<nz-date-picker *ngSwitchCase="'PastDate'" [nzDisabled]="true"></nz-date-picker>
					<nz-date-picker *ngSwitchCase="'FutureDate'" [nzDisabled]="true"></nz-date-picker>
					<nz-time-picker *ngSwitchCase="'Time'" [nzDisabled]="true"></nz-time-picker>
					<nz-time-picker *ngSwitchCase="'PastDateTime'" [nzDisabled]="true"></nz-time-picker>
					<nz-time-picker *ngSwitchCase="'FutureDateTime'" [nzDisabled]="true"></nz-time-picker>
					<button *ngSwitchCase="'File'" nz-button [disabled]="true"><nz-icon nzType="upload" />Click to Upload</button>
					<input *ngSwitchDefault nz-input [attr.readonly]="true || null" />
				</nz-input-group>
				<nz-input-group  *ngIf="isProductWorkflow" [ngSwitch]="item._dataType">
					<textarea *ngSwitchCase="'TextArea'" nz-input [attr.readonly]="true || null"></textarea>
					<label *ngSwitchCase="'Boolean'" nz-checkbox [nzDisabled]="true">{{item._label}}</label>
					<label *ngSwitchCase="'RequiredCheckbox'" nz-checkbox [nzDisabled]="true">{{item._label}}</label>
					<nz-select *ngSwitchCase="'DropDownSingle'" [nzDisabled]="true">
						<nz-option *ngFor="let option of item.options" [nzValue]="option._value" [nzLabel]="option._label??'No Label'"></nz-option>
					</nz-select>
					<nz-select *ngSwitchCase="'DependantList'" [nzDisabled]="true"></nz-select>
					<nz-select *ngSwitchCase="'ICD10'" [nzDisabled]="true"></nz-select>
					<nz-select *ngSwitchCase="'MemberAndDependantList'" [nzDisabled]="true"></nz-select>
					<input *ngSwitchCase="'Number'" nz-input [attr.readonly]="true || null" />
					<nz-date-picker *ngSwitchCase="'PastDate'" [nzDisabled]="true"></nz-date-picker>
					<nz-date-picker *ngSwitchCase="'FutureDate'" [nzDisabled]="true"></nz-date-picker>
					<nz-time-picker *ngSwitchCase="'Time'" [nzDisabled]="true"></nz-time-picker>
					<nz-time-picker *ngSwitchCase="'PastDateTime'" [nzDisabled]="true"></nz-time-picker>
					<nz-time-picker *ngSwitchCase="'FutureDateTime'" [nzDisabled]="true"></nz-time-picker>
					<button *ngSwitchCase="'File'" nz-button [disabled]="true"><nz-icon nzType="upload" />Click to Upload</button>
					<input *ngSwitchDefault nz-input [attr.readonly]="true || null" />
				</nz-input-group>
			</nz-form-control>
			<ng-template #deleteElementTmpl>
				<nz-tag nzColor="red" class="float-end" (click)="removeElement(item)">
					<fa-icon [icon]="faTrash"></fa-icon>
				</nz-tag>
			</ng-template>
		</nz-form-item>
		<button *ngIf="!isProductWorkflow"  nz-button nzType="dashed" class="mt-2" (click)="addElement()">+ Add Element</button>
	</nz-card>
</form>


<ng-template #editPopup>
	<form [formGroup]="input.formGroup">

		<nz-form-item>
			<nz-form-label [nzSpan]="6" nzRequired>
				<app-invalid-form-indicator [form]="input.formGroup" field="label" class="me-3"></app-invalid-form-indicator>
				Label
			</nz-form-label>
			<nz-form-control [nzSpan]="14">
				<input nz-input formControlName="label"  [attr.readonly]="isProductWorkflow || null"/>
			</nz-form-control>
		</nz-form-item>

		<nz-form-item>
			<nz-form-label [nzSpan]="6" nzRequired>
				<app-invalid-form-indicator [form]="input.formGroup" field="sectionOrder" class="me-3"></app-invalid-form-indicator>
				Section Order
			</nz-form-label>
			<nz-form-control [nzSpan]="14">
				<input nz-input type="number" formControlName="sectionOrder" [attr.readonly]="isProductWorkflow || null" />
			</nz-form-control>
		</nz-form-item>

		<nz-form-item>
			<nz-form-label [nzSpan]="6" [nzRequired]="true" >
				<app-invalid-form-indicator [form]="input.formGroup" field="statusIds" class="me-3"></app-invalid-form-indicator>
				Statuses
			</nz-form-label>
			<nz-form-control [nzSpan]="14">
				<nz-select
					nzMode="multiple"
					nzPlaceHolder="Select statuses"
					formControlName="statusIds"
					[nzOptions]="statusOptions"
					[nzDisabled]="isProductWorkflow">
				</nz-select>
			</nz-form-control>
		</nz-form-item>
	</form>
</ng-template>
